import {
  AccordionModule,
  CheckboxModule,
  ConfirmDialogModule,
  DropdownModule,
  FileUploadModule,
  InputTextModule,
  StepsModule,
  ToastModule,
  EditorModule,
  ProgressSpinnerModule,
  PaginatorModule,
  InputSwitchModule,
  TooltipModule,
  RadioButtonModule,
  ButtonModule,
  DialogModule,
  OverlayPanelModule,
  CardModule,
  CalendarModule,
} from 'primeng';
import { QuillModule } from 'ngx-quill';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
//components
import { LoaderComponent } from './components/loader/loader.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { CompanyDataComponent } from './components/company-data/company-data.component';
import { OrderHistoryComponent } from './components/order-history/order-history.component';
import { LockUnlockComponent } from './components/lock-unlock-buttons/lock-unlock.component';
import { SectionHeaderComponent } from './components/section-header/section-header.component';
import { SectionCommentComponent } from './components/section-comment/section-comment.component';
import { TechnicianInfoComponent } from './components/technician-info/technician-info.component';
import { ApplicationStepsComponent } from './components/application-steps/application-steps.component';
import { PersonDataFieldsComponent } from './components/person-data-fields/person-data-fields.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
//services
import { EnvironmentService } from '../services/environment.service';
//directives
import { IbanValidDirective } from './directives/iban-valid.directive';
import { EmailValidDirective } from './directives/email-valid.directive';
import { StringMatchDirective } from './directives/string-match.directive';
//others
import { StringifiedDatePipe } from './pipes/stringified-date.pipe';
import { PendingChangesGuard } from './guards/pending-changes-guard.servie';
import { ErrorHandlingModule } from '../+error-handling/error-handling.module';
import { CustomFieldsComponent } from './custom-fields/custom-fields.component';
import { OnlyDigitsDirective } from './directives/allow-only-digits.directive';
import { ReviewSectionComponent } from './components/review-section/review-section.component';
import { ReviewMessageInputComponent } from './components/review-section/review-message-input/review-message-input.component';
import { ReviewMessageContainerComponent } from './components/review-section/review-message-container/review-message-container.component';
import { ContactPersonComponent } from './components/contact-person/contact-person.component';
import { DocumentEditorComponent } from './components/document-editor/document-editor.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { translateModule } from './shared.translate.module';
import { PlusButtonComponent } from './components/plus-button/plus-button.component';
import { ButtonDeleteComponent } from './components/button-delete/button-delete.component';
import { ApplicationStepsGenericComponent } from './components/application-steps-generic/application-steps-generic.component';
import { ConsumptionDeviceStepsComponent } from './consumption-device-steps/consumption-device-steps.component';
import { DocumentsSubmissionComponent } from './components/documents-submission/documents-submission.component';
import { NavStepsComponent } from './components/nav-steps/nav-steps.component';
import { EnterClickDirective } from '../directives/enter-click.directive';
import { CalendarEscapeCloseDirective } from '../directives/calendar-escape-close.directive';

@NgModule({
  declarations: [
    EnterClickDirective,
    CalendarEscapeCloseDirective,
    ApplicationStepsComponent,
    ApplicationStepsGenericComponent,
    PersonDataFieldsComponent,
    FileUploadComponent,
    LockUnlockComponent,
    OrderHistoryComponent,
    LoaderComponent,
    SectionCommentComponent,
    StringifiedDatePipe,
    CustomFieldsComponent,
    StringMatchDirective,
    OnlyDigitsDirective,
    EmailValidDirective,
    IbanValidDirective,
    SectionHeaderComponent,
    ConfirmationModalComponent,
    TechnicianInfoComponent,
    CompanyDataComponent,
    ReviewSectionComponent,
    ReviewMessageInputComponent,
    ReviewMessageContainerComponent,
    ContactPersonComponent,
    DocumentEditorComponent,
    TooltipComponent,
    PlusButtonComponent,
    ButtonDeleteComponent,
    ConsumptionDeviceStepsComponent,
    DocumentsSubmissionComponent,
    NavStepsComponent,
  ],
  imports: [
    ConfirmDialogModule,
    PaginatorModule,
    ProgressSpinnerModule,
    AccordionModule,
    CommonModule,
    StepsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    InputSwitchModule,
    TooltipModule,
    RadioButtonModule,
    EditorModule,
    FileUploadModule,
    CheckboxModule,
    ToastModule,
    ButtonModule,
    ErrorHandlingModule,
    DialogModule,
    OverlayPanelModule,
    CardModule,
    CalendarModule,
    QuillModule.forRoot(),
    translateModule,
  ],
  exports: [
    EnterClickDirective,
    CalendarEscapeCloseDirective,
    ApplicationStepsComponent,
    ApplicationStepsGenericComponent,
    PersonDataFieldsComponent,
    FileUploadComponent,
    LockUnlockComponent,
    OrderHistoryComponent,
    LoaderComponent,
    SectionCommentComponent,
    CustomFieldsComponent,
    StringifiedDatePipe,
    StringMatchDirective,
    OnlyDigitsDirective,
    EmailValidDirective,
    IbanValidDirective,
    SectionHeaderComponent,
    ConfirmationModalComponent,
    TechnicianInfoComponent,
    CompanyDataComponent,
    ReviewSectionComponent,
    ContactPersonComponent,
    DocumentEditorComponent,
    TooltipComponent,
    PlusButtonComponent,
    ButtonDeleteComponent,
    ConsumptionDeviceStepsComponent,
    DocumentsSubmissionComponent,
    NavStepsComponent,
  ],
  providers: [EnvironmentService, ConfirmationService, PendingChangesGuard, DatePipe],
})
export class SharedModule {}
